import { useCallback, useEffect, useRef, useState } from 'react';
import type {
  TimelineMessageActivity,
  TimelineMessageActivityParams,
} from '../../types/timeline/new-message-activity.types';
import { advanceTimelineMessageActivity } from '../../utils/timeline/new-message-activity.util';

/** Tracks only this mounted reader's arrivals; closing the chat discards the counter. */
export const useTimelineNewMessages = ({
  items,
  scopeKey,
  ready,
  isAtBottom,
}: TimelineMessageActivityParams) => {
  const state = useRef<TimelineMessageActivity | null>(null);
  const [count, setCount] = useState(0);
  useEffect(() => {
    state.current = advanceTimelineMessageActivity(state.current, {
      items,
      scopeKey,
      ready,
      isAtBottom,
    });
    setCount(state.current?.count ?? 0);
  }, [items, scopeKey, ready, isAtBottom]);
  const clear = useCallback(() => {
    if (state.current) state.current = { ...state.current, count: 0 };
    setCount(0);
  }, []);
  return { count: state.current?.scopeKey === scopeKey ? count : 0, clear };
};
